import { baseQualityEnv } from './base.quality';
import { Environments } from './types';

export const environment: Environments = baseQualityEnv;
